//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerBackTitle from '@/components/header/headerBackTitleShare'
export default{
  components:{
    headerBackTitle,
  },
  data(){
      return{
        shareInfo:{},     //app分享信息
        newsInfo:[],
        newsOneUrl:'',
        newsOneImg:'',
        newsOneTitle:'',
        sortIndex:1,
        zc_header:false,
      }
  },
  methods:{
    getNewsList(){
      var data = {
        "txnBodyCom": {
          "column_code":this.$route.query.newsId,
          "handleWay":"0"
        },
        "txnCommCom": {
          "tRecInPage": 50,
          "tPageJump": this.sortIndex,

        }
      }
      this.$https.get(this.CCY_URL+'/ccy/advert/fp/fsx11004?column_code='+this.$route.query.newsId+'&handleWay=0&current='+this.sortIndex+'&size=50').then(res => {
        console.log(res)
        // this.spotN = res.data.data.fabulous;
        if(res.data.code==0){
          this.newsInfo = res.data.data.records
          console.log(this.newsInfo);
          this.newsOneUrl = this.newsInfo[0].news_id;
          this.newsOneImg = this.newsInfo[0].thumbnail_url;
          this.newsOneTitle = this.newsInfo[0].news_title;

          if(this.newsInfo.length>1){
            //                this.newsInfo = [...this.newsInfo, ...res.result.informationInfos];
            this.newsInfo = res.data.data.records
            this.newsInfo = this.newsInfo.splice(1,this.newsInfo.length);
          }
          this.wechatshareneedkey();
        }
      })

    },
      goNewsDet(e){      //新闻详情
        let linkUrl = location.protocol+'//'+location.host+'/gzddpt/index.html#/cmsDetail?id='+e
        // if(this.isWeixinCient()){
        //   window.location.href = linkUrl
        // }else {
        //   window.click.onItemClick(linkUrl)
        // }
        window.location.href = linkUrl
      },
      wechatshareneedkey  () {
        if(this.isWeixinCient()){
          let lineLink=window.location.href.split('#')[0];//要分享页面的地址，即该页面地址
          this.shareInfo = {
            title : '专题报道',
            desc: this.newsOneTitle,
            link : this.appjump_url+'/pages/index/#/zcnewsList?newsId='+this.$route.query.newsId+'&isShare=share',
            imgUrl: this.newsOneImg
          };
          this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
          this.setWeixinConfig(this.shareInfo);
        }else{
          this.shareInfo = '{"picurl":"'+this.newsOneImg+'","title":"专题报道","type":"'+2+'","projectId":"","text":"'+this.newsOneTitle+'","url":"'+this.appjump_url+'/pages/index/#/zcnewsList?newsId='+this.$route.query.newsId+'&isShare=share","ischange":'+'"2"'+'}'
          this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
        }
      },
      ifFollow(){
        let self = this;
        this.$jsonp(this.wechat_url+"shfpwebwx/wechatAuth/getIsAttention",{
          'openid':localStorage.getItem('zcopenid')
        }).then( data => {
          if(data.result.subscribe=="0"){//未关注
            if(this.$route.query.isShare == "share"){//分享出去的
              if(this.isWeixinCient()){
                //关注公共号 头部定位
                self.zc_header = true;
              }
            }

          }
        })
      },
      refresh (done) {
        setTimeout(() => {
//          this.sortIndex = 1;
//          this.newsInfo = {};
//          this.getNewsList(done);
          done()
        },1000)
      },
      infinite (done) {
        setTimeout(() => {
//            if(this.sortIndex < 2){
//              this.sortIndex++
//              this.getNewsList(done);
//              done()
//            }else{
              done(true)
//            }
        },1000)
      },
  },
  mounted(){
      this.getNewsList();
  },
  created(){
      this.ifFollow();
  }
}



// WEBPACK FOOTER //
// ./src/crowd_fund/newsList.vue